exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ServiceBlock_component_Fuv6 {\n  padding: 32px 0\n}\n.ServiceBlock_component_Fuv6 + .ServiceBlock_component_Fuv6 {\n  border-top: 1px solid #dfe0e5;\n}\n.ServiceBlock_component_Fuv6:first-child {\n  padding-top: 16px;\n}\n.ServiceBlock_component_Fuv6:last-child {\n  padding-bottom: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ServiceBlock_component_Fuv6"
};